/**
 * Wrapper for vuex useStore to avoid vue-tsc type resolution issues
 * in <script setup lang="ts"> blocks.
 *
 * @see https://github.com/vuejs/language-tools/issues/xxx
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - vuex types resolution issue in vue-tsc
import { useStore as vuexUseStore } from 'vuex';

export const useStore = vuexUseStore;
